import React, {useState} from 'react'
import header from './Header.module.scss'
import logo from '../../image/Header/logo.svg'
import HeaderContact from '../../components/HeaderContact/HeaderContact'

const Header = () => {

    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 10){
            setVisible(true)
        } 
        else if (scrolled <= 10){
            setVisible(false)
        }
    }

    window.addEventListener('scroll', toggleVisible);


    return (
        <header className={`${header.header} ${visible && header.header_scroll}`}>
        <div className={header.box}>
            <div className={header.logo_link}>
                <img className={header.logo} src={logo} alt = 'логотип'/>
            </div>
            <div className={header.box_min}>
                <HeaderContact/>    
            </div>
                
        </div>
    </header>    
    );
};

export default Header